// extracted by mini-css-extract-plugin
export default {"th":"CollectionContentTable_th__gf1Yx","control":"CollectionContentTable_control__ZeKcS","icon":"CollectionContentTable_icon__ftA4+"};